<template>
    <div class="vue-treeselect__multi-value-item-container">
        <template v-if="instance.$slots['value-label']">
            <component :is="instance.$slots['value-label']" v-bind="{ node, remove: () => instance.select( node ) }" />
        </template>
        <Tag v-else :class="itemClass" @on:remove="instance.select( node )">
            {{ node.label }}
        </Tag>
    </div>
</template>

<script>
import { onLeftClick } from '../utils';

import DeleteIcon from './icons/Delete.vue';

export default
{
    name        : 'Treeselect--multi-value-item',
    inject      : [ 'instance' ],
    props       : { node: { type: Object, required: true } },
    components  : { DeleteIcon },
    computed    :
    {
        itemClass()
        {
            const { instance, node } = this;

            return (
            {
                'primary'                                   : true,
                'error'                                     : node.isDisabled,
                'vue-treeselect__multi-value-item'          : true,
                'vue-treeselect__multi-value-item-disabled' : node.isDisabled,
                'vue-treeselect__multi-value-item-new'      : node.isNew,
                'sm'                                        : true
                //[ instance.class?.split(' ')?.find( f => ['sm','md','lg'].includes( f ) )]  : true
            })
        }
    },
    methods :
    {
        handleMouseDown: onLeftClick( function handleMouseDown()
        {
            const { instance, node } = this;

            instance.select( node ); // Deselect this node.
        })
    },

    /*
    render()
    {
        const { instance, node } = this;

        const itemClass =
        {
            'vue-treeselect__multi-value-item'          : true,
            'vue-treeselect__multi-value-item-disabled' : node.isDisabled,
            'vue-treeselect__multi-value-item-new'      : node.isNew,
        }

        const customValueLabelRenderer = instance.$slots['value-label'];
        const labelRenderer = customValueLabelRenderer ? customValueLabelRenderer({ node }) : node.label;

        return (
            <div class="vue-treeselect__multi-value-item-container">
                <div class={itemClass} onMousedown={this.handleMouseDown}>
                    <span class="vue-treeselect__multi-value-label">{ labelRenderer }</span>
                    <span class="vue-treeselect__icon vue-treeselect__value-remove"><DeleteIcon /></span>
                </div>
            </div>
        )
    }
    */
}
</script>
